module.exports = __webpack_public_path__ + "img/offers.c468c41e.png";